import { post } from '@/utils/examMan/request'

export function fetchToken() {
  // return post('/api/learn/api/common/qiniu/token')
  return post('/api/learn/api/course/file/qiniu/token')
}
